import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Web3Context } from '../../context/Web3Context';
import { shortenAddress } from '../../utils/formatters';
import './Navbar.css';

const Navbar = () => {
  const { account, isRegistered, isAdmin, connectWallet, disconnectWallet, isConnecting, userId } = useContext(Web3Context);
  const location = useLocation();

  return (
    <>
      <nav className="navbar">
        <div className="navbar-inner">
          <Link to="/" className="navbar-logo">
            <img src="/logo.png" alt="UltraCapital" className="logo-img" />
            <span className="logo-text">Ultra<span className="logo-accent">Capital</span></span>
          </Link>

          <div className="navbar-right">
            {account && isAdmin && (
              <Link to="/admin" className="admin-link">Admin</Link>
            )}
            {account && userId ? (
              <div className="user-badge">
                <span className="user-id">ID: {userId}</span>
              </div>
            ) : null}
            {account ? (
              <button className="wallet-btn connected" onClick={disconnectWallet}>
                <span className="wallet-dot"></span>
                {shortenAddress(account)}
              </button>
            ) : (
              <button className="wallet-btn" onClick={connectWallet} disabled={isConnecting}>
                {isConnecting ? 'Connecting...' : 'Connect'}
              </button>
            )}
          </div>
        </div>
      </nav>

      {account && isRegistered && (
        <nav className="bottom-bar">
          <Link to="/dashboard" className={`bottom-tab ${location.pathname === '/dashboard' ? 'active' : ''}`}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <rect x="3" y="3" width="7" height="7" rx="1" strokeLinecap="round"/><rect x="14" y="3" width="7" height="7" rx="1" strokeLinecap="round"/><rect x="3" y="14" width="7" height="7" rx="1" strokeLinecap="round"/><rect x="14" y="14" width="7" height="7" rx="1" strokeLinecap="round"/>
            </svg>
            <span>Dashboard</span>
          </Link>
          <Link to="/packages" className={`bottom-tab ${location.pathname === '/packages' ? 'active' : ''}`}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Packages</span>
          </Link>
          <Link to="/team" className={`bottom-tab ${location.pathname === '/team' ? 'active' : ''}`}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M16 21v-2a4 4 0 00-4-4H6a4 4 0 00-4 4v2" strokeLinecap="round" strokeLinejoin="round"/><circle cx="9" cy="7" r="4"/><path d="M22 21v-2a4 4 0 00-3-3.87M16 3.13a4 4 0 010 7.75" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Team</span>
          </Link>
          <Link to="/pools" className={`bottom-tab ${location.pathname === '/pools' ? 'active' : ''}`}>
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>Pools</span>
          </Link>
        </nav>
      )}
    </>
  );
};

export default Navbar;
